import useLocalStorageState from "use-local-storage-state";
import { User } from "@labs/shared/types/User";

export const useLocalUserState = () =>
  useLocalStorageState<User>("user", {
    defaultValue: {
      name: null,
      email: null,
      jobTitle: null,
      organizationName: null,
      industryType: null,
      readableIndustryType: null,
      marketingOptIn: true,
      planEmailed: false,
      firstPassComplete: false,
      viewedPlanComponents: [],
    },
  });
